import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import ReduceCapacityIcon from "@mui/icons-material/ReduceCapacity";
import DoorFrontIcon from "@mui/icons-material/DoorFront";
import {
  BooleanField,
  Button,
  ChipField,
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ReferenceArrayField,
  ShowButton,
  SimpleList,
  SingleFieldList,
  TextField,
  TopToolbar,
} from "react-admin";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import {
  ActivityServicePath,
  ASSIGNMENTS,
  FOREIGN_LANGUAGES,
  LEVELS,
  MANAGE_CAPACITY,
  MOBILE_BREAKPOINT,
} from "utils/constants";
import { activityRequests } from "api/activityApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListActions = hasCreate => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <SecuredComponent permission={permissions.canManageStudentsForeignLanguages}>
        <Button
          startIcon={<DoorFrontIcon />}
          label="Входни изпити"
          onClick={() =>
            navigate("/" + ActivityServicePath + "students/" + FOREIGN_LANGUAGES + "/" + LEVELS + "/" + ASSIGNMENTS)
          }
        />
      </SecuredComponent>
      <SecuredComponent permission={permissions.canPreviewForeignLanguagesCapacities}>
        <Button
          startIcon={<ReduceCapacityIcon />}
          label="Капацитет"
          onClick={() => navigate("/" + MANAGE_CAPACITY + "/" + FOREIGN_LANGUAGES)}
        />
      </SecuredComponent>
      {hasCreate && <CreateButton />}
    </TopToolbar>
  );
};

const ListActivityForeignLanguages = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Чужди езици"
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageActivitiesForeignLanguages)} />
      }
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Име на български език", value: <TextField source="nameBg" /> }]} />
              <MobileListRow fields={[{ label: "Име на английски език", value: <TextField source="nameEn" /> }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Входящ тест", value: record?.hasEntryTest ? "Да" : "Не" }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Ниво",
                    value: (
                      <ReferenceArrayField
                        source="levels"
                        reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
                      >
                        <SingleFieldList linkType={false}>
                          <ChipField source="name" />
                        </SingleFieldList>
                      </ReferenceArrayField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageActivitiesForeignLanguages}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewActivitiesForeignLanguages}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <BooleanField
            label="Входящ тест"
            source="hasEntryTest"
          />
          <ReferenceArrayField
            label="Ниво"
            source="levels"
            reference={activityRequests.getActivityForeignLanguagesLevelsSelect()}
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
          <SecuredComponent permission={permissions.canManageActivitiesForeignLanguages}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewActivitiesForeignLanguages}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListActivityForeignLanguages;
